import { ChangeDetectionStrategy, Component, Inject, OnInit } from '@angular/core';
import { DotCMSNavigationItem } from 'dotcms/src/lib/models';
import { Observable } from 'rxjs';

import { MAIN_NAVIGATION_MAX_SUB_CATEGORIES_DEPTH } from 'ish-core/configurations/injection-keys';
import { AppFacade } from 'ish-core/facades/app.facade';
import { DeviceType } from 'ish-core/models/viewtype/viewtype.types';
import { InjectSingle } from 'ish-core/utils/injection';
import { GenerateLazyComponent } from 'ish-core/utils/module-loader/generate-lazy-component.decorator';

import { DotCmsFacade } from '../../facades/dot-cms.facade';
import { dotCMSNavigationLink, isIndexPagePresent } from '../../utils/dot-cms-utils';

@Component({
  selector: 'custom-dot-cms-header-navigation',
  templateUrl: './dot-cms-header-navigation.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
@GenerateLazyComponent()
export class DotCmsHeaderNavigationComponent implements OnInit {
  navLinks$: Observable<DotCMSNavigationItem>;
  dotCMSHeaderNavigationLink = dotCMSNavigationLink;
  isHavingIndexPage = isIndexPagePresent;
  openedPages: DotCMSNavigationItem[] = [];
  deviceType$: Observable<DeviceType>;
  constructor(
    private appFacade: AppFacade,
    @Inject(MAIN_NAVIGATION_MAX_SUB_CATEGORIES_DEPTH)
    public mainNavigationMaxSubFoldersDepth: InjectSingle<typeof MAIN_NAVIGATION_MAX_SUB_CATEGORIES_DEPTH>,
    private dotCmsFacade: DotCmsFacade
  ) {}
  ngOnInit() {
    this.navLinks$ = this.dotCmsFacade.fetchHeaderLinks$();
    this.deviceType$ = this.appFacade.deviceType$;
  }
}
